"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CubicBezierControl = void 0;
const Point2D_1 = require("./Point2D");
/**
 * Represents a cubic bezier line control
 */
class CubicBezierControl {
    constructor({ c1, c2 }) {
        this.c1 = new Point2D_1.Point2D(c1);
        this.c2 = new Point2D_1.Point2D(c2);
    }
    /**
     * Creates a new cubic bezier control based on extracting specific properties from any provided object
     * @param data - An `ICubicBezierControl` object with `c1` and `c2` point properties
     * @returns A new `CubicBezierControl` object
     */
    static BuildFromJSON({ c1, c2 }) {
        return new CubicBezierControl({ c1, c2 });
    }
    /**
     * Returns a new control created from bounding each point to the `Rect` object provided
     * @remarks This method bounds the control points to the rect with coordinates `[0, 0] x [r.width, r.height]`.
     * @param r - A bounding box
     * @returns A new `CubicBezierControl` object, with control coordinates bounded to the box
     */
    boundToRect(r) {
        return new CubicBezierControl({ c1: this.c1.boundToRect(r), c2: this.c2.boundToRect(r) });
    }
    /**
     * Shifts the control by specified delta.
     * Modifies control in place.
     * @param dx - Delta to be added to the `x`-coordinate
     * @param dy - Delta to be added to the `y`-coordinate
     */
    shift(dx, dy) {
        this.c1.shift(dx, dy);
        this.c2.shift(dx, dy);
    }
    /**
     * Creates a copy of this control
     * @returns A new `Point2D` object with copied coordinates
     */
    copy() {
        return new CubicBezierControl(this);
    }
    /**
     * Returns a string representation of the point in the format `"{x, y}"`.
     * @returns A string representation of the point
     */
    toString() {
        return `{${this.c1.toString()}, ${this.c2.toString()}}`;
    }
    /**
     * Returns a JSON representation of the point
     * @returns An `IPoint` object with `x` and `y` numeric properties.
     */
    toJSON() {
        return {
            c1: this.c1.toJSON(),
            c2: this.c2.toJSON(),
        };
    }
}
exports.CubicBezierControl = CubicBezierControl;
//# sourceMappingURL=CubicBezierControl.js.map